export const DETAIL_PANES = ['summary', 'log'] as const;

export const DETAIL_PANE_LABELS = { summary: 'Summary', log: 'Time log' } as const;

export const LOG_GRID_PREFIX = 'log_';

export const BILLABLE_OPTIONS = [
  { value: 'billable', label: 'Billable' },
  { value: 'nonbillable', label: 'Non-billable' },
];

export const ALL_PORTFOLIOS = 'all';

export const CLIENT_GRID_PREFIX = 'cli_';

export const ROLE_LABELS = { cfo: 'CFO', dataTeam: 'Data team' } as const;

// Logged hours are the solid mark; hours still to log wear the same hue faded,
// so the two read as one person's load.
export const ROLE_BAR_CLASS = {
  cfo: { logged: 'bg-capacity-cfo', remaining: 'bg-capacity-cfo/30' },
  dataTeam: { logged: 'bg-capacity-data', remaining: 'bg-capacity-data/30' },
} as const;

export const ROLE_DOT_CLASS = { cfo: 'bg-capacity-cfo', dataTeam: 'bg-capacity-data' } as const;

export const COMPOSITION_KEYS = ['cfo', 'dataTeam', 'unassigned'] as const;

export const COMPOSITION_LABELS = {
  cfo: 'CFO',
  dataTeam: 'Data team',
  unassigned: 'Unassigned',
} as const;

export const COMPOSITION_CLASS = {
  cfo: 'bg-capacity-cfo',
  dataTeam: 'bg-capacity-data',
  unassigned: 'bg-capacity-rail',
} as const;

export const BUDGET_BUCKETS = [
  { key: 'fixed', label: 'Fixed' },
  { key: 'variable', label: 'Variable' },
] as const;

// Plain-language answers to "what is this?" for the figures a new CFO meets
// first on Capacity.
export const TERM_HELP = {
  engagement:
    'The hours your clients pay for this month: their fixed retainer plus any variable hours.',
  assigned:
    'How much of the engagement has been handed to someone, split between the CFO and the Data team. Whatever is left shows as unassigned.',
  logged: 'The hours actually logged in ClickUp this month.',
  month:
    'How far into the month we are: weekdays so far, today included, out of all the weekdays in the month.',
  forecast:
    'Where the month is likely to end up. It takes the higher of two numbers: the hours logged plus the hours still estimated on open tasks, or the hours logged so far carried on at this month’s pace.',
  overage:
    'Hours logged above what the client pays for. Fixed and variable hours are counted separately, so going over on one is not covered by the other.',
} as const;

// Keyed by column id, so a column only gets an explanation where one is written.
export const CLIENT_COLUMN_HELP: Partial<Record<string, string>> = {
  forecast: TERM_HELP.forecast,
  overage: TERM_HELP.overage,
};
